import {
  ADD_TEST_TO_CART,
  CLEAR_TEST_CART,
  GET_TEST_CART,
  SET_TEST_CART,
  TOGGLE_TEST_CART,
  SET_TEST_CART_LOADING,
  REMOVE_TEST_FROM_CART,
} from "../../actions";

const initialState = {
  items: [],
  loading: true,
};

const PurchaseTestReducer = (state = initialState, action) => {
    console.log("action", action.type);
  switch (action.type) {
    case ADD_TEST_TO_CART: {
    
      if (!state.items.includes(action.payload)) {
        return {
          ...state,
          items: [...state.items, action.payload],
        };
      }
      return state;
    }

    case REMOVE_TEST_FROM_CART: {
      return {
        ...state,
        items: state.items.filter((item) => item?.id !== action.payload.id),
      };
    }

    case CLEAR_TEST_CART: {
      return {
        ...state,
        items: [],
      };
    }
    // ✅ new: get all wishlist items
    case GET_TEST_CART: {
      return {
        ...state,
        items: state.items, // just return current state
      };
    }

    case SET_TEST_CART_LOADING:
      return { ...state, loading: action.payload };


  case SET_TEST_CART:
  return { 
    ...state, 
    items: action.payload|| [], 
    loading: false 
  };


    // ✅ toggle wishlist item
    case TOGGLE_TEST_CART: {
      const exists = state.items.find((item) => item.id === action.payload.id);
      if (exists) {
        // remove if already in list
        return {
          ...state,
          items: state.items.filter((item) => item.id !== action.payload.id),
        };
      } else {
        // add if not in list
        return {
          ...state,
          items: [...state.items, action.payload],
        };
      }
    }

    default:
      return state;
  }
};

export default PurchaseTestReducer;
